export default {
  'menu.dashboard': 'Dashboard',
  'pages.dashboard.action.refresh': 'Refresh',
  'pages.dashboard.ai.activeUsers': 'Active users',
  'pages.dashboard.ai.avgLatencyMs': 'Avg latency',
  'pages.dashboard.ai.avgResponseTimeMs': 'Avg response time',
  'pages.dashboard.ai.caCalls': 'CA calls',
  'pages.dashboard.ai.completionTokens': 'Completion tokens',
  'pages.dashboard.ai.cost': 'Cost',
  'pages.dashboard.ai.errorCalls': 'Error calls',
  'pages.dashboard.ai.failedCalls': 'Failed calls',
  'pages.dashboard.ai.inputTokens': 'Input tokens',
  'pages.dashboard.ai.mbotCalls': 'Mbot calls',
  'pages.dashboard.ai.modelDistribution': 'Model usage',
  'pages.dashboard.ai.outputTokens': 'Output tokens',
  'pages.dashboard.ai.promptTokens': 'Prompt tokens',
  'pages.dashboard.ai.successCalls': 'Successful calls',
  'pages.dashboard.ai.successRate': 'Success rate',
  'pages.dashboard.ai.title': 'AI operations',
  'pages.dashboard.ai.today': 'Today',
  'pages.dashboard.ai.totalCalls': 'Total calls',
  'pages.dashboard.ai.totalGroups': 'Total groups',
  'pages.dashboard.ai.totalTokens': 'Total tokens',
  'pages.dashboard.ai.totalUsers': 'Total users',
  'pages.dashboard.ai.tokens': 'Tokens',
  'pages.dashboard.ai.trend': 'Trend',
  'pages.dashboard.ai.yesterday': 'Yesterday',
  'pages.dashboard.chart.metricFilter': 'Metric filter',
  'pages.dashboard.chart.selectMetrics': 'Select metrics',
  'pages.dashboard.empty.aiRemote': 'No AI operations data',
  'pages.dashboard.empty.chart': 'No trend data',
  'pages.dashboard.empty.overview': 'No overview data',
  'pages.dashboard.empty.risk': 'No risk data',
  'pages.dashboard.empty.riskList': 'No records',
  'pages.dashboard.empty.segments': 'No segment data',
  'pages.dashboard.empty.statusBreakdown': 'No status data',
  'pages.dashboard.empty.timApp': 'No TIM app data',
  'pages.dashboard.empty.timAppList': 'No records',
  'pages.dashboard.field.date': 'Date',
  'pages.dashboard.growth.activeUsers': 'Active users',
  'pages.dashboard.growth.newUsers': 'New users',
  'pages.dashboard.growth.newVipUsers': 'New VIP users',
  'pages.dashboard.growth.profileCompletedUsers': 'Profile completed users',
  'pages.dashboard.growth.title': 'User growth',
  'pages.dashboard.growth.totalUsers': 'Total users',
  'pages.dashboard.meetings.callDialCount': 'Dial calls today',
  'pages.dashboard.meetings.createCount': 'Meetings created today',
  'pages.dashboard.meetings.title': 'Today meeting metrics',
  'pages.dashboard.meetings.trendTitle': 'Meeting trend',
  'pages.dashboard.message.aiRemoteFailed':
    'Failed to load AI operations data: {reason}',
  'pages.dashboard.message.growthFailed':
    'Failed to load user growth trend: {reason}',
  'pages.dashboard.message.meetingDailyFailed':
    'Failed to load meeting trend: {reason}',
  'pages.dashboard.message.meetingsTodayFailed':
    'Failed to load today meeting metrics: {reason}',
  'pages.dashboard.message.ordersTodayFailed':
    'Failed to load today order metrics: {reason}',
  'pages.dashboard.message.overviewFailed':
    'Failed to load user overview: {reason}',
  'pages.dashboard.message.riskFailed':
    'Failed to load risk governance data: {reason}',
  'pages.dashboard.message.segmentsFailed':
    'Failed to load user segments: {reason}',
  'pages.dashboard.message.timAppFailed':
    'Failed to load TIM app data: {reason}',
  'pages.dashboard.overview.activeUsers': 'Active users',
  'pages.dashboard.overview.bannedUsers': 'Banned users',
  'pages.dashboard.overview.blockUsers': 'Blocked users',
  'pages.dashboard.overview.complainants': 'Complainants',
  'pages.dashboard.overview.complaints': 'Complaints',
  'pages.dashboard.overview.disabledUsers': 'Disabled users',
  'pages.dashboard.overview.newUsers': 'New users',
  'pages.dashboard.overview.newVipUsers': 'New VIP users',
  'pages.dashboard.overview.onlineUsers': 'Online users',
  'pages.dashboard.overview.profileCompletedUsers': 'Profile completed users',
  'pages.dashboard.overview.profileCompletionRate': 'Profile completion rate',
  'pages.dashboard.overview.reportedTargets': 'Reported targets',
  'pages.dashboard.overview.risk': 'Risk',
  'pages.dashboard.overview.riskUsers': 'Risk users',
  'pages.dashboard.overview.tim': 'TIM',
  'pages.dashboard.overview.tim.activeUserNum': 'Active users',
  'pages.dashboard.overview.tim.apnsMsgNum': 'APNS messages',
  'pages.dashboard.overview.tim.appId': 'App ID',
  'pages.dashboard.overview.tim.c2cApnsMsgNum': 'C2C APNS messages',
  'pages.dashboard.overview.tim.c2cDownMsgNum': 'C2C down messages',
  'pages.dashboard.overview.tim.c2cSendMsgUserNum': 'C2C send message users',
  'pages.dashboard.overview.tim.c2cUpMsgNum': 'C2C up messages',
  'pages.dashboard.overview.tim.callbackReq': 'Callback requests',
  'pages.dashboard.overview.tim.callbackRsp': 'Callback responses',
  'pages.dashboard.overview.tim.chainDecrease': 'Chain decrease',
  'pages.dashboard.overview.tim.chainIncrease': 'Chain increase',
  'pages.dashboard.overview.tim.date': 'Date',
  'pages.dashboard.overview.tim.downMsgNum': 'Down messages',
  'pages.dashboard.overview.tim.groupAllGroupNum': 'Total groups',
  'pages.dashboard.overview.tim.groupApnsMsgNum': 'Group APNS messages',
  'pages.dashboard.overview.tim.groupDestroyGroupNum': 'Destroyed groups',
  'pages.dashboard.overview.tim.groupDownMsgNum': 'Group down messages',
  'pages.dashboard.overview.tim.groupJoinGroupTimes': 'Group join times',
  'pages.dashboard.overview.tim.groupNewGroupNum': 'New groups',
  'pages.dashboard.overview.tim.groupQuitGroupNum': 'Group quit times',
  'pages.dashboard.overview.tim.groupQuitGroupTimes': 'Group quit times',
  'pages.dashboard.overview.tim.groupSendMsgGroupNum':
    'Groups sending messages',
  'pages.dashboard.overview.tim.groupSendMsgNum': 'Group sent messages',
  'pages.dashboard.overview.tim.groupSendMsgUserNum':
    'Group send message users',
  'pages.dashboard.overview.tim.groupUpMsgNum': 'Group up messages',
  'pages.dashboard.overview.tim.loginTimes': 'Login times',
  'pages.dashboard.overview.tim.loginUserNum': 'Login users',
  'pages.dashboard.overview.tim.mau': 'MAU',
  'pages.dashboard.overview.tim.maxOnlineNum': 'Max online users',
  'pages.dashboard.overview.tim.qq': 'QQ',
  'pages.dashboard.overview.tim.registUserNum': 'Registered users',
  'pages.dashboard.overview.tim.registUserNumOne': 'New registered users',
  'pages.dashboard.overview.tim.registUserNumOneDay':
    'New registered users today',
  'pages.dashboard.overview.tim.registUserNumTotal': 'Total registered users',
  'pages.dashboard.overview.tim.sendMsgUserNum': 'Send message users',
  'pages.dashboard.overview.tim.upMsgNum': 'Up messages',
  'pages.dashboard.overview.timUsers': 'TIM users',
  'pages.dashboard.overview.title': 'User overview',
  'pages.dashboard.overview.totalUsers': 'Total users',
  'pages.dashboard.overview.user': 'User',
  'pages.dashboard.overview.verifiedUsers': 'Verified users',
  'pages.dashboard.overview.vipUsers': 'VIP users',
  'pages.dashboard.orders.activeUsers': 'Active users',
  'pages.dashboard.orders.orderCount': 'Orders today',
  'pages.dashboard.orders.refundAmount': 'Refund amount',
  'pages.dashboard.orders.refundCount': 'Refunds',
  'pages.dashboard.orders.revenue': 'Revenue today',
  'pages.dashboard.orders.statusBreakdown': 'Order status breakdown',
  'pages.dashboard.orders.title': 'Today order metrics',
  'pages.dashboard.orders.totalOrders': 'Total orders',
  'pages.dashboard.risk.bannedUsers': 'Banned users',
  'pages.dashboard.risk.blockCount': 'Blocks',
  'pages.dashboard.risk.blockedUid': 'Blocked UID',
  'pages.dashboard.risk.blockedUsers': 'Blocked users',
  'pages.dashboard.risk.blockerUid': 'Blocker UID',
  'pages.dashboard.risk.complainantUid': 'Complainant UID',
  'pages.dashboard.risk.complainantCount': 'Complainants',
  'pages.dashboard.risk.complainants': 'Complainants',
  'pages.dashboard.risk.complaintCount': 'Complaints',
  'pages.dashboard.risk.complaintType': 'Complaint type',
  'pages.dashboard.risk.complaintTypeDistribution':
    'Complaint type distribution',
  'pages.dashboard.risk.complaints': 'Complaints',
  'pages.dashboard.risk.count': 'Count',
  'pages.dashboard.risk.date': 'Date',
  'pages.dashboard.risk.disabledUsers': 'Disabled users',
  'pages.dashboard.risk.from': 'From',
  'pages.dashboard.risk.keyword': 'Keyword',
  'pages.dashboard.risk.rank': 'No.',
  'pages.dashboard.risk.reason': 'Reason',
  'pages.dashboard.risk.reportCount': 'Reports',
  'pages.dashboard.risk.reportedTargetCount': 'Reported targets',
  'pages.dashboard.risk.reportedTargets': 'Reported targets',
  'pages.dashboard.risk.reportedUid': 'Reported UID',
  'pages.dashboard.risk.riskScore': 'Risk score',
  'pages.dashboard.risk.targetUid': 'Target UID',
  'pages.dashboard.risk.title': 'Risk governance',
  'pages.dashboard.risk.to': 'To',
  'pages.dashboard.risk.topBlocked': 'Top blocked users',
  'pages.dashboard.risk.topBlockers': 'Top blockers',
  'pages.dashboard.risk.topComplainants': 'Top complainants',
  'pages.dashboard.risk.topReportedTargets': 'Top reported targets',
  'pages.dashboard.risk.total': 'Total',
  'pages.dashboard.risk.uid': 'UID',
  'pages.dashboard.segments.age': 'Age',
  'pages.dashboard.segments.banned': 'Banned',
  'pages.dashboard.segments.disabled': 'Disabled',
  'pages.dashboard.segments.female': 'Female',
  'pages.dashboard.segments.gender': 'Gender',
  'pages.dashboard.segments.level': 'Level',
  'pages.dashboard.segments.male': 'Male',
  'pages.dashboard.segments.normal': 'Normal',
  'pages.dashboard.segments.other': 'Other',
  'pages.dashboard.segments.region': 'Region',
  'pages.dashboard.segments.status': 'Status',
  'pages.dashboard.segments.title': 'User segments',
  'pages.dashboard.segments.unknown': 'Unknown',
  'pages.dashboard.segments.vip': 'VIP',
  'pages.dashboard.segments.vipLevel': 'VIP level',
  'pages.dashboard.timApp.callbackChain': 'Callback and chain',
  'pages.dashboard.timApp.groupActivity': 'Group activity',
  'pages.dashboard.timApp.messageTraffic': 'Message traffic',
  'pages.dashboard.timApp.record': 'Record',
  'pages.dashboard.timApp.title': 'TIM app operations',
  'pages.dashboard.timApp.today': 'Today',
  'pages.dashboard.timApp.trend': 'Trend',
  'pages.dashboard.timApp.userActivity': 'User activity',
  'pages.dashboard.title': 'Dashboard',
  'pages.dashboard.updatedAt': 'Updated at {time}',
};
